export default "__VITE_ASSET__DU_N444I__"